import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Option from '../MultipleChoice/Option';
import classNames from 'classnames';
import './styles.styl';

const SelectObject = ({
  data,
  validationResult,
  isFinalAttempt,
  onInput,
  setSubmitStatus,
  correctInput,
  input
}) => {
  const hasValidated = validationResult !== null;

  const cardSelect = (e, card, hasValidated) => {
    e.preventDefault();
    if (hasValidated) return;
    setSubmitStatus(true);
    const payload = {
      [data.question]: card
    };
    onInput(payload);
  };

  const isChecked = option => {
    if (input) {
      return input[data.question] === option;
    }
  };

  const getFeedback = option => {
    const { question } = data;
    const correctOption = correctInput ? correctInput[question] : correctInput;

    if (hasValidated && correctInput) {
      if (correctOption === option) {
        return 'success';
      }
      if (input[question] === option) {
        return 'error';
      }
    }
    return null;
  };

  const cardClassName = option => {
    return classNames(
      isChecked(option) &&
        isFinalAttempt &&
        `select-object-card--${getFeedback(option)}`,
      {
        'select-object-card--selected': input && option === input[data.question]
      },
      'comet-card comet-card--white modal-cards__card select-object-card'
    );
  };

  return (
    <Fragment>
      <h3>{data.question}</h3>
      <div className="comet-cards">
        {data.cards &&
          data.cards.map((card, i) => {
            return (
              <a
                key={i}
                className={cardClassName(card.label)}
                role="Option"
                tabIndex={i + 1}
                onClick={e => cardSelect(e, card.label, hasValidated)}
                onKeyPress={e => cardSelect(e, card.label, hasValidated)}
                aria-selected={false} // TODO: This needs to tie into if this is selected or not - DUH
              >
                {card.image && <img src={card.image} alt={card.imageText} />}
                <Option
                  question={card.label}
                  type="radio"
                  data={{
                    label: card.label
                  }}
                  readOnly={hasValidated}
                  checked={isChecked(card.label)}
                  onClick={e => cardSelect(e, card.label)}
                  feedback={getFeedback(card.label)}
                  isFinalAttempt={isFinalAttempt}
                />
                <div className="select-object-card__text">
                  {card.text && card.text}
                </div>
              </a>
            );
          })}
        <div className="comet-card comet-card--invisible" />
        <div className="comet-card comet-card--invisible" />
        <div className="comet-card comet-card--invisible" />
      </div>
    </Fragment>
  );
};

export default SelectObject;

SelectObject.propTypes = {
  data: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ../core/src/components/SelectObject/SelectObject.js